import { defaultSettings } from '../pages/owner/settings/settingsData';

let cachedSettings = { ...defaultSettings, currency: { ...defaultSettings.currency } };

export function getPlatformSettings() {
  return cachedSettings;
}

export function setPlatformSettingsCache(settings) {
  if (!settings) return cachedSettings;
  cachedSettings = {
    softwareName: settings.softwareName || defaultSettings.softwareName,
    currency: {
      code: settings.currency?.code || defaultSettings.currency.code,
      symbol: settings.currency?.symbol || defaultSettings.currency.symbol,
      position: settings.currency?.position || defaultSettings.currency.position,
      decimalPlaces: Number(settings.currency?.decimalPlaces ?? defaultSettings.currency.decimalPlaces),
    },
  };
  return cachedSettings;
}

export function formatPlatformPrice(amount, settings = cachedSettings) {
  const currency = settings?.currency || defaultSettings.currency;
  const decimals = Number(currency.decimalPlaces ?? 2);
  const formatted = Number(amount || 0).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const symbol = currency.symbol || '$';
  return currency.position === 'after'
    ? `${formatted} ${symbol}`
    : `${symbol} ${formatted}`;
}

export function formatPlatformCompact(amount, settings = cachedSettings) {
  const currency = settings?.currency || defaultSettings.currency;
  const symbol = currency.symbol || '$';
  const n = Number(amount || 0);
  const compact = n >= 1000 ? `${(n / 1000).toFixed(0)}k` : String(Math.round(n));
  return currency.position === 'after' ? `${compact} ${symbol}` : `${symbol}${compact}`;
}
